import { useConfigurationIntValue } from "./useConfigurationIntValue";

// Returns a number representing the desired polling interval in milliseconds
export function useSearchDebounceInterval(): number {
  return useConfigurationIntValue("SEARCH_DEBOUNCE_INTERVAL", 1200);
}
